import React from 'react';

interface InnerHTMLStyleProps {
  mediaQuery?: string;
  imageSrc?: string;
}

const InnerHTMLStyle = ({ mediaQuery, imageSrc }: InnerHTMLStyleProps) => {
  if (!mediaQuery || !imageSrc) return null;

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
            @media (${mediaQuery}) {
                [data-wx-hero] .hero-background-image {
                    background-image: url(${imageSrc});
                }
            }
        `,
      }}
    />
  );
};

interface HeroImageProps {
  imageDesktop?: string;
  imageMobile?: string;
}

const HeroImage = ({ imageDesktop, imageMobile }: HeroImageProps) => (
  <>
    {imageDesktop && <InnerHTMLStyle mediaQuery="min-width: 900px" imageSrc={imageDesktop} />}
    {imageMobile && <InnerHTMLStyle mediaQuery="max-width: 899px" imageSrc={imageMobile} />}
  </>
);

export default HeroImage;
